// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../../../common/temp/default/node_modules/.pnpm/@rsbuild+core@1.1.13/node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../../common/temp/default/node_modules/.pnpm/@rsbuild+core@1.1.13/node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.config-status-lyxnOS .markdown-KP_VTq{max-width:265px;color:var(--light-usage-text-color-text-0,#1d1c23);font-size:12px;line-height:16px}.config-status-lyxnOS .semi-tag{margin-right:4px;font-weight:500}.config-status-lyxnOS .semi-tag svg{width:10px;height:10px;margin-left:4px}.config-status-lyxnOS .semi-button-borderless{height:24px;padding:0 8px;font-size:12px;line-height:20px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"config-status": `config-status-lyxnOS`,
	"configStatus": `config-status-lyxnOS`,
	"markdown": `markdown-KP_VTq`
};
export default ___CSS_LOADER_EXPORT___;
